import { type EventMetadata } from './events';

const MAX_METADATA_BYTES = 3500; // backend rejects envelopes >= 5000 bytes total

function byteLength(value: unknown): number {
  return new TextEncoder().encode(JSON.stringify(value)).length;
}

export function truncatePayload(metadata: EventMetadata): EventMetadata {
  const originalBytes = byteLength(metadata);
  if (originalBytes <= MAX_METADATA_BYTES) return metadata;

  const result: EventMetadata = { ...metadata };

  while (byteLength(result) > MAX_METADATA_BYTES) {
    let longestKey: string | null = null;
    let longestLen = 0;
    for (const [key, value] of Object.entries(result)) {
      if (typeof value === 'string' && value.length > longestLen) {
        longestKey = key;
        longestLen = value.length;
      }
    }
    if (longestKey == null) break;

    const current = result[longestKey] as string;
    const newLen = Math.floor(current.length / 2);
    if (newLen === current.length) break;
    result[longestKey] = current.slice(0, newLen);
  }

  result.truncated = true;
  result.original_total_bytes = originalBytes;
  return result;
}
